import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from 'morpheus-ui';
import { ComponentProps } from 'react';
import {
  ToastContainer,
  ToastPosition,
  toast as toastEmmiter,
} from 'react-toastify';
import { VariantProps } from 'tailwind-variants';
import './style.css';
import { toastIcon, toasty } from './variants';
import { Typography } from '../../molecules/Typography';

type ToastProps = ComponentProps<'div'> &
  VariantProps<typeof toasty> & {
    variant: string;
    title?: string;
    message?: string;
    toastId?: string;
    autoClose?: number;
    position?: ToastPosition;
  };

const iconMap = {
  info: InfoIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  success: SuccessIcon,
};

export function Toast() {
  return (
    <ToastContainer
      autoClose={4000}
      hideProgressBar={true}
      closeButton={false}
    />
  );
}

export function toast({
  variant = 'info',
  title,
  message,
  className,
  position,
  toastId,
  autoClose = 4000,
  ...props
}: ToastProps) {
  const IconComponent = iconMap[variant];

  const toastContent = () => {
    return (
      <div
        {...props}
        className={toasty({ variant, className }) + ' border-mono-color-white'}
      >
        <IconComponent className={toastIcon({ variant })} />
        <div className='m-auto flex-1'>
          <Typography size='h6' weight='bold'>
            {title}
          </Typography>
          <Typography>{message}</Typography>
        </div>
      </div>
    );
  };

  return toastEmmiter(toastContent, { position, autoClose, toastId });
}
